// 引入依赖
import Vue from 'vue';
import Vuex from 'vuex';

// 引入state 模块
import actions from './actions';
import mutations from './mutations';
import states from './states';

// 使用 vuex
Vue.use(Vuex);

const store = new Vuex.Store({
  state: states,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js